import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';
import type { components } from '@/shared/api/openapi';

export interface UseDistributorGroupUserMembershipOptions {
  organizationId: number;
  groupId: number;
  userIds: string[];
  enabled?: boolean;
}

type DistributorGroupUserMembershipResult = components['schemas']['CheckDistributorGroupUserMembershipEndpoint_Response'];

export function useDistributorGroupUserMembership({
  organizationId,
  groupId,
  userIds,
  enabled = true,
}: UseDistributorGroupUserMembershipOptions) {
  const { getAccessToken } = useAuth();

  return useQuery({
    queryKey: ['distributor-group-user-membership', organizationId, groupId, userIds],
    queryFn: async ({ signal }) => {
      const client = createApiClient(getAccessToken, {
        cache: 'no-store',
        signal,
      });

      const { data, error } = await client.POST('/api/organizations/{organizationId}/distributor-groups/{groupId}/users/check', {
        params: {
          path: { organizationId, groupId },
        },
        body: { userIds },
      });

      if (error) {
        throw error;
      }

      return (data ?? []) as DistributorGroupUserMembershipResult[];
    },
    enabled: enabled && userIds.length > 0,
    staleTime: 10000,
  });
}
